<template>
  <div>
    <top-nav-bar />
    <router-view class="main-content" />
    <div id="fixed-modal" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TopNavBar from '@/components/TopNavBar'

export default {
  components: {
    TopNavBar
  },
  computed: {
    ...mapState([
      'loggedUser',
      'services'
    ])
  },
  async created () {
    if (this.loggedUser && !this.loggedUser.roles.includes('admin')) {
      if (Object.keys(this.loggedUser.acl).length === 1) {
        const key = Object.keys(this.loggedUser.acl)[0]
        this.$router.push({ name: 'ServicePage', params: { serviceID: key } })
      } else {
        await this.fetchProfile()
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchProfile',
      'fetchService'
    ])
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/_variables.scss";

html {
  font-size: 100%;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  -webkit-box-sizing: inherit;
  box-sizing: inherit;
  word-wrap: break-word;
}

body {
  font-size: 1rem;
  font-family: 'Source Sans Pro', sans-serif;
}

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

p,
h1,
h2 {
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  background: none;
  border: 0;
  padding: 0;
}

button:hover {
  cursor: pointer;
}

button,
input,
optgroup,
select,
textarea {
  font-family: "Source Sans Pro", sans-serif;
}

fieldset {
  border: 0;
  padding: 0;
  margin: 0;
}

.details-list {
  margin: 0;
  color: #45555f;
  font-weight: 600;
}

.details-list dt {
  opacity: 0.5;
  font-size: 0.75rem;
  text-transform: uppercase;
}

.details-list dd {
  margin: 0;
  font-size: 1.125rem;
  margin-top: 0.1875rem;
  margin-bottom: 0.9375rem;
  padding-bottom: 0.9375rem;
  border-bottom: 0.0625rem solid rgba(28, 23, 47, 0.1);
}

.user-email {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon {
  text-indent: 200%;
  white-space: nowrap;
  overflow: hidden;
}

.icon-arrow__back {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  margin-right: 1.25rem;
}

.icon-arrow__back::after {
  border-color: rgba(28, 23, 47, 0.6);
}

.icon-clock {
  background: url("~@/assets/images/icon-clock.svg") no-repeat 0.625rem center;
  padding-left: 2rem !important;
}

.btn-edit {
  background: url("~@/assets/images/edit.svg") no-repeat center 0.5625rem;
}

.btn-more-actions {
  background: url("~@/assets/images/more-actions.svg") no-repeat center 0.625rem;
}

.btn-delete {
  background: url("~@/assets/images/delete.svg") no-repeat center 0.5625rem;
}

.tv-device {
  background: url("~@/assets/images/tv.svg") no-repeat left 0.1875rem;
}

.tablet-device {
  background: url("~@/assets/images/tablet.svg") no-repeat left 0.1875rem;
}

.clock-icon {
  padding-left: 3.75rem;
  background: url("~@/assets/images/clock.svg") no-repeat 0.375rem center;
}

@-webkit-keyframes autofill {
  to {
    background: transparent;
  }
}

@keyframes autofill {
  to {
    background: transparent;
  }
}

input:-webkit-autofill {
  -webkit-animation-name: autofill;
  animation-name: autofill;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

::-webkit-input-placeholder {
  opacity: 0.5;
}

::-moz-placeholder {
  opacity: 0.5;
}

:-ms-input-placeholder {
  opacity: 0.5;
}

form p {
  margin: 0 0 1.5rem;
  font-size: 1.125rem;
  line-height: 1.5;
}

.input {
  position: relative;
}

.input-group ~ .input-group {
  margin-top: 1.25rem;
}

.hours-block {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;
}

.hours-block ~ .hours-block {
  margin-top: 0.625rem;
}

.hours-block .input-select {
  width: 40%;
}

.icon-remove {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 100%;
  background-image: none;
  background-color: #e3e8ed;
  -webkit-transition: background-color 0.3s ease, -webkit-transform 0.3s ease;
  transition: background-color 0.3s ease, -webkit-transform 0.3s ease;
  transition: background-color 0.3s ease, transform 0.3s ease;
  transition: background-color 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
}

.icon-remove::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 0.5rem;
  height: 0.0625rem;
  background-color: #594996;
}

.icon-remove:hover,
.icon-remove:focus {
  background-color: #d3dbe3;
}

.hours-block .icon-remove {
  position: absolute;
  left: 103%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

fieldset legend,
.input-group label {
  margin-bottom: 0.5rem;
  display: block;
}

.select-icon,
.btn-select {
  position: relative;
}

.select-icon::before,
.btn-select::before {
  position: absolute;
  content: "";
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 1.25rem;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 0.375rem solid transparent;
  border-right: 0.375rem solid transparent;
  border-top: 0.375rem solid #000;
}

.btn-select select {
  padding-right: 2.5rem;
}

#form-edit-queue label {
  opacity: 0.6;
}

select,
input[type="text"],
input[type="number"],
input[type="time"],
.btn-input {
  width: 100%;
  appearance: none;
  background: #fff;
  border: 0.0625rem solid rgba(69, 85, 95, 0.4);
  border-radius: 0.125rem;
  height: 2.75rem;
  padding: 0 0.75rem;
  font-size: 1.125rem;
  font-weight: 700;
  outline: 0;
  text-align: left;
  transition: all 0.3s ease;
}

select:focus,
input[type="text"]:focus,
input[type="time"]:focus,
.btn-input:focus {
  border: 0.0625rem solid #0076dc;
  -webkit-box-shadow: 0 0 0 0.125rem #0076dc;
  box-shadow: 0 0 0 0.125rem #0076dc;
}

.field-error select,
.field-error input[type="text"],
.field-error input[type="time"],
.field-error .btn-input {
  border: 0.0625rem solid #e24e58;
  -webkit-box-shadow: 0 0 0 0.125rem #e24e58;
  box-shadow: 0 0 0 0.125rem #e24e58;
}

.leave-table {
  display: flex;
  align-items: center;
  color: $gray;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: $blue-600;

    .leave-table__icon .icon-fill {
      fill: $blue-600;
    }
  }
}

.error-message {
  color: #e24e58;
  display: block;
  margin-top: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
}

.range-slider {
  position: relative;
}

.range-feedback {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  width: calc(50% - 0.5rem);
  max-width: 100%;
  content: "";
  background: #0076dc;
  height: 0.125rem;
  pointer-events: none;
  z-index: 1;
  -webkit-transition: width 0.3s ease;
  transition: width 0.3s ease;
}

output {
  position: absolute;
  background-color: #0076dc;
  width: 2.125rem;
  height: auto;
  padding: 0.125rem 0 0.25rem;
  text-align: center;
  color: #fff;
  border-radius: 0.1875rem;
  bottom: 150%;
  left: 0;
  font-size: 1rem;
  font-weight: 600;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: left 0.3s ease, margin-left 0.3s ease;
  transition: left 0.3s ease, margin-left 0.3s ease;
}

output::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 0.375rem solid #0076dc;
  border-left: 0.3125rem solid transparent;
  border-right: 0.3125rem solid transparent;
  top: 100%;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

.input-range input[type=range] {
  -webkit-appearance: none;
  margin: 0.625rem 0;
  width: 11.25rem;
  outline: none;
}

.input-range input[type=range]:focus::-webkit-slider-thumb,
.input-range input[type=range]:active::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0 0 0.125rem rgba(0, 137, 224, 0.5);
  box-shadow: 0 0 0 0.125rem rgba(0, 137, 224, 0.5);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.input-range input[type=range]:focus::-moz-range-thumb,
.input-range input[type=range]:active::-moz-range-thumb {
  box-shadow: 0 0 0 0.125rem rgba(0, 137, 224, 0.5);
  transform: scale(1.1);
}

.input-range input[type=range]:focus::-ms-thumb,
.input-range input[type=range]:active::-ms-thumb {
  box-shadow: 0 0 0 0.125rem rgba(0, 137, 224, 0.5);
  transform: scale(1.1);
}

.input-range input[type=range]:focus + output,
.input-range input[type=range]:hover + output,
.input-range input[type=range]:active + output {
  opacity: 1;
  visibility: visible;
}

.input-range input[type=range]::-webkit-slider-runnable-track {
  width: 11.25rem;
  height: 0.125rem;
  cursor: pointer;
  background: #bdc2c8;
  border-radius: 0.0625rem;
  border: 0;
}

.input-range input[type=range]::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.2);
  height: 1rem;
  width: 1rem;
  border-radius: 0.5rem;
  background-color: #fff;
  border: 0.0625rem solid rgba(28, 23, 47, 0.2);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -0.4375rem;
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  position: relative;
  z-index: 9999;
}

.input-range input[type=range]::-moz-range-track {
  width: 11.25rem;
  height: 0.125rem;
  cursor: pointer;
  background: #bdc2c8;
  border-radius: 0.0625rem;
  border: 0;
}

.input-range input[type=range]::-moz-range-thumb {
  box-shadow: 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.2);
  height: 1rem;
  width: 1rem;
  border-radius: 0.5rem;
  background-color: #fff;
  border: 0.0625rem solid rgba(28, 23, 47, 0.2);
  cursor: pointer;
  margin-top: -0.4375rem;
  -webkit-transition: -webkit-transform 0.3s ease;
  transition: -webkit-transform 0.3s ease;
  transition: transform 0.3s ease;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  position: relative;
  z-index: 9999;
}

.input-range input[type=range]::-moz-focus-outer {
  border: 0;
}

.input-range input[type=range]::-ms-track {
  width: 11.25rem;
  height: 0.125rem;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}

.input-range input[type=range]::-ms-fill-lower {
  background: #bdc2c8;
  border: 0 solid #000;
  border-radius: 0.0625rem;
}

.input-range input[type=range]::-ms-fill-upper {
  background: #bdc2c8;
  border: 0 solid #000;
  border-radius: 0.0625rem;
}

.input-range input[type=range]::-ms-thumb {
  box-shadow: 0 0.125rem 0.25rem 0 rgba(0, 0, 0, 0.2);
  height: 1rem;
  width: 1rem;
  border-radius: 0.5rem;
  background-color: #fff;
  border: 0.0625rem solid rgba(28, 23, 47, 0.2);
  cursor: pointer;
  margin-top: -0.4375rem;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 9999;
}

.input-group .input-checkbox {
  display: flex;
  align-items: center;
}

.input-group .input-checkbox__label {
  order: 2;
  margin-bottom: 0;
  margin-left: 0.375rem;
}

.input-text--prefixed {
  padding-left: 2.25rem !important;
}

.input-text .input-text__prefix {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  user-select: none;
  font-size: 1.125rem;
  font-weight: 700;
}

.input-group .input + .input {
  margin-top: 1rem;
}

.select-list {
  border: 0.0625rem solid rgba(69, 85, 95, 0.4);
  border-bottom-left-radius: 0.125rem;
  border-bottom-right-radius: 0.125rem;
  padding: 0.375rem 0;
  background-color: #fff;
  overflow: hidden;
  max-height: 12.5rem;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  left: 0;
  top: 100%;
  z-index: 9999;
  display: none;
}

.select-list-open {
  height: auto;
  margin: -0.0625rem 0 2.5rem;
  -webkit-box-shadow: 0 0.1875rem 0.4375rem rgba(0, 0, 0, 0.14);
  box-shadow: 0 0.1875rem 0.4375rem rgba(0, 0, 0, 0.14);
  display: block;
}

.select-list .select-item {
  position: relative;
  padding: 0.375rem 0.75rem;
  font-size: 1.125rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.select-list .select-item:hover {
  background-color: #0076dc;
}

.select-list .select-item:hover label {
  color: #fff;
}

.select-list .select-item:hover input:checked + label {
  color: #fff;
}

.select-list .select-item input {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 2;
  order: 2;
}

.select-list .select-item input:checked + label {
  color: #0076dc;
}

.select-list .select-item label {
  -webkit-box-ordinal-group: 2;
  -ms-flex-order: 1;
  order: 1;
  margin-bottom: 0;
  cursor: pointer;
}

.select-list .select-item label::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

.form-actions .main-action {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 2;
  order: 2;
  margin-left: 0.5rem;
}

hr {
  border: 0;
  height: 1px;
  margin: 1rem 0;
  opacity: 0.5;
  background: #d8d8d8;
}

/* loading dots */

.dots--calling::after {
  content: ".";
  animation: dots 1s steps(5, end) infinite;
}

@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: white;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
  }
}

// #ticket-attend {
//   position: relative;
//   margin-bottom: 2rem;

//   &:after {
//     position: absolute;
//     content: "";
//     width: 100%;
//     bottom: -1rem;
//     left: 0;
//     height: 1px;
//     opacity: 0.5;
//     background: #D8D8D8;
//   }
// }

// Specific SIGA buttons

.next-step {
  min-width: 1.25rem;
}

.next-step::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.next-step::after {
  position: absolute;
  top: 50%;
  right: 0.625rem;
  content: "";
  width: 0.75rem;
  height: 0.75rem;
  border: 0.1875rem solid rgba(28, 23, 47, 0.4);
  border-left: 0;
  border-bottom: 0;
  transform: rotate(45deg) translateY(-50%);
  border-radius: 1px;
  transition: all 0.3s ease;
}

.step-back::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 3.75rem;
  height: 100%;
  z-index: 0;
  border-radius: 0.125rem;
}

.step-back::after {
  position: absolute;
  // top: 38%;
  top: 25px;
  transform: rotate(-135deg) translateY(-50%);
  left: 2.375rem;
  content: "";
  width: 0.75rem;
  height: 0.75rem;
  border: 0.1875rem solid rgba(28, 23, 47, 0.4);
  border-left: 0;
  border-bottom: 0;
  border-radius: 0.0625rem;
  transition: all 0.3s ease;
}

.next-step:hover::after,
.next-step:focus::after,
.step-back:hover::after,
.step-back:focus::after {
  border-color: #0076dc;
}

.btn-checkbox.checkbox-focus:focus:checked + .switch-label {
  box-shadow: 0 0 0 0.1875rem rgba(#199d5b, 0.5);
}

.btn-checkbox.checkbox-focus:focus + .switch-label {
  box-shadow: 0 0 0 0.1875rem rgba(#e9374f, 0.5);
}

.btn-switch + .switch-label {
  position: relative;
  display: block;
  width: 120px;
  height: 32px;
  cursor: pointer;
  user-select: none;
  background: #e9374f;
  border-radius: 1.125rem;
  padding: 0.125rem;
  transition: all 0.4s ease;
}

.btn-switch:checked + .switch-label {
  background: #199d5b;
}

.btn-switch + .switch-label::after {
  position: relative;
  left: 0;
  display: block;
  content: "";
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 0 rgba(0, 0, 0, 0.08);
  transition: left 0.4s cubic-bezier(0.75, -0.2, 0.5, 1.15);
}

.btn-switch:checked + .switch-label::after {
  left: 88px;
}

.switch-status {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  line-height: 33px;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
}

.switch-status__off {
  left: 37px;
  opacity: 1;
}

.switch-status__on {
  opacity: 0;
}

.switch-status__off,
.switch-status__on {
  transition: all 0.4s ease;
}

.btn-switch:checked + .switch-label .switch-status__off {
  opacity: 0;
}

.btn-switch:checked + .switch-label .switch-status__on {
  left: 20px;
  opacity: 1;
}

.btn-logout {
  width: 1.25rem;
  height: 1.875rem;
  border: 0;
  background-color: transparent;
  color: transparent;
  margin-left: 0.5rem;
  padding: 0.375rem 0;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.5;
  -webkit-transition: opacity 0.3s ease, -webkit-transform 0.3s ease;
  transition: opacity 0.3s ease, -webkit-transform 0.3s ease;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transition: opacity 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
  -webkit-transform-origin: left center;
  transform-origin: left center;
}

.btn-logout:hover,
.btn-logout:focus {
  opacity: 1;
}

.btn-locate-tv {
  margin-left: 0.625rem;
  -webkit-transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

.btn-locate-tv:hover {
  background-color: #0076dc;
  border-color: #0076dc;
  color: #fff;
}

.btn-add-hours-block {
  margin-top: 0.625rem;
  color: #0076dc;
  font-weight: 600;
  font-size: 0.875rem;
  padding-left: 1rem;
  position: relative;
}

.btn-add-hours-block::before,
.btn-add-hours-block::after {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  width: 0.625rem;
  height: 0.125rem;
  border-radius: 0.0625rem;
  background-color: #0076dc;
  -webkit-transition: background 0.3s ease;
  transition: background 0.3s ease;
}

.btn-add-hours-block::before {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.btn-add-new {
  padding-left: 2.75rem;
  padding-left: 3.75rem;
  position: relative;
  opacity: 0.6;
  -webkit-transition: opacity 0.3s ease, color 0.3s ease;
  transition: opacity 0.3s ease, color 0.3s ease;
}

.btn-add-new:hover {
  opacity: 1;
  color: #0076dc;
}

.btn-add-new:hover::before,
.btn-add-new:hover::after {
  background-color: #0076dc;
}

.btn-add-new::before,
.btn-add-new::after {
  position: absolute;
  content: "";
  top: 50%;
  left: 0.0813rem;
  width: 0.75rem;
  height: 0.125rem;
  border-radius: 0.0625rem;
  background-color: #1c172f;
  -webkit-transition: background 0.3s ease;
  transition: background 0.3s ease;
}

.btn-add-new::before {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

*[class*="btn-"] .icon-clock {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 0.375rem;
  display: inline-block;
  vertical-align: middle;
}

p + button,
p + .btn,
p + .btn-primary,
p + .btn-secondary,
p + .btn-light,
p + .btn-warning {
  margin-top: 1.25rem;
}

// Dropdowns

.button-dropdown {
  position: relative;
}

.system-notifications {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 2.75rem;
  z-index: 9999;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.notification-item {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #4d4179;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  -webkit-box-shadow: 0 0.1875rem 0.4375rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.1875rem 0.4375rem 0 rgba(0, 0, 0, 0.1);
  padding: 0 1.875rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.notification-item .notifications-count {
  margin-right: 0.3125rem;
}

.notification-item p {
  color: inherit;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.notification-item .btn-close__notifications {
  margin-top: 0;
}

.notification-item .btn-close__notifications:hover .icon-close__notifications {
  fill: #fff;
  stroke: #45555f;
}

.notification-item .icon-close__notifications {
  margin: 0;
  color: inherit;
  font-weight: inherit;
  stroke: #fff;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.notification-warning {
  background-color: #e24e58;
}

.notification-warning .btn-close__notifications:hover .icon-close__notifications {
  fill: #fff;
  stroke: #e24e58;
}

.notification-item--top {
  z-index: 9999;
}

.system-notifications + .main-operations {
  transform: translateY(2.75rem);
  max-height: calc(100vh - 2.75rem);
}

.system-notifications.moves-up {
  -webkit-transform: translateY(-105%);
  transform: translateY(-105%);
}

.notification-item.moves-up {
  -webkit-transform: translateY(-105%);
  transform: translateY(-105%);
}

.main-operations.moves-up {
  transform: translateY(0);
  max-height: 100vh;
}

.modal-close {
  position: fixed;
  top: 2.5rem;
  right: 3.75rem;
  width: 3.125rem;
  height: 3.125rem;
  z-index: 9999;
  border-radius: 100%;
  background-color: rgba(28, 23, 47, 0.05);
  color: #1c172f;
  line-height: 8;
  font-size: 0.875rem;
  -webkit-transition: background-color 0.3s ease, -webkit-transform 0.3s ease;
  transition: background-color 0.3s ease, -webkit-transform 0.3s ease;
  transition: background-color 0.3s ease, transform 0.3s ease;
  transition: background-color 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
}

.modal-close::before,
.modal-close::after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  width: 1.125rem;
  height: 0.1875rem;
  border-radius: 0.125rem;
  background-color: #657d8b;
  -webkit-transform-origin: left;
  transform-origin: left;
  -webkit-transition: background 0.3s ease;
  transition: background 0.3s ease;
}

.modal-close::before {
  -webkit-transform: rotate(45deg) translateX(-50%);
  transform: rotate(45deg) translateX(-50%);
}

.modal-close::after {
  -webkit-transform: rotate(-45deg) translateX(-50%);
  transform: rotate(-45deg) translateX(-50%);
}

.modal-close:hover,
.modal-close:focus {
  background-color: #e3e8ed;
}

.modal-close:hover::before,
.modal-close:hover::after,
.modal-close:focus::before,
.modal-close:focus::after {
  background-color: #45555f;
}
@media (min-height: 25rem) {
  .modal-container {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .modal-box {
    margin-top: 0;
  }

  .modal-content > :last-child {
    margin-bottom: 0;
  }
}

.sr-only,
.empty-state .modal-header {
  border: 0;
  clip: rect(0 0 0 0);
  height: 0.0625rem;
  margin: -0.0625rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 0.0625rem;
}

.modal-window {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  -webkit-transition: opacity 0.3s ease, visibility 0.3s ease;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.modal-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(0.625rem);
  transform: translateY(0.625rem);
  -webkit-transition: opacity 0.3s ease, visibility 0.3s ease, -webkit-transform 0.3s ease;
  transition: opacity 0.3s ease, visibility 0.3s ease, -webkit-transform 0.3s ease;
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease, -webkit-transform 0.3s ease;
}

.modal-window-open {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.modal-window-open .modal-container {
  opacity: 1;
  visibility: visible;
  -webkit-transform: none;
  transform: none;
}

.modal-box {
  width: 26.25rem;
  height: auto;
  padding: 3.125rem 3.125rem 2.75rem;
  margin-top: 6.25rem;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.modal-box--large {
  width: 100%;
  max-width: 43.125rem;
}

.modal-header {
  width: 100%;
  color: #000;
  margin-bottom: 1rem;
}

.modal-content > :last-child {
  margin-bottom: 6.25rem;
}

.main-operations {
  height: 100vh;
  display: flex;
  flex-grow: 1;
  max-height: 100vh;
  transition: all 0.3s ease-in-out;
}

.btn-call,
.btn-call--filled,
.modal-close,
.btn,
.btn-primary,
.btn-secondary,
.btn-light,
.btn-warning {
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.btn-call:active,
.btn-call--filled:active,
.modal-close:active,
.btn:active,
.btn-primary:active,
.btn-secondary:active,
.btn-light:active,
.btn-warning:active {
  -webkit-transform: scale(0.96);
  transform: scale(0.96);
}

.btn,
.btn-primary,
.btn-secondary,
.btn-light,
.btn-warning {
  // display: inline-block;
  border: 0.125rem solid #0076dc;
  color: #0076dc;
  border-radius: 0.25rem;
  // font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  // text-transform: uppercase;
  padding: 0.5625rem 0.875rem;
}

.btn.btn-disabled,
.btn-disabled.btn-primary,
.btn-disabled.btn-secondary,
.btn-disabled.btn-light,
.btn-disabled.btn-warning,
.btn[disabled],
[disabled].btn-primary,
[disabled].btn-secondary,
[disabled].btn-light,
[disabled].btn-warning {
  opacity: 0.4;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.btn-primary {
  border: 0.125rem solid #0076dc;
  color: #0076dc;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary.btn-active,
.btn-primary.btn-primary--filled {
  background-color: #0076dc;
  border-color: #0076dc;
  color: #fff;
}

.btn-primary.btn-active:hover,
.btn-primary.btn-active:focus,
.btn-primary.btn-primary--filled:hover,
.btn-primary.btn-primary--filled:focus {
  background-color: #2eaeff;
  border-color: #2eaeff;
}

.btn-secondary {
  border-color: rgba(69, 85, 95, 0.3);
  color: #45555f;
}

.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary.btn-active,
.btn-secondary.btn-secondary--filled {
  background-color: rgba(69, 85, 95, 0.05);
  border-color: rgba(69, 85, 95, 0.6);
  color: #45555f;
}

.btn-secondary.btn-active:hover,
.btn-secondary.btn-active:focus,
.btn-secondary.btn-secondary--filled:hover,
.btn-secondary.btn-secondary--filled:focus {
  background-color: rgba(69, 85, 95, 0.1);
}

.btn-light {
  color: #fff;
  border-color: #fff;
}

.btn-light .icon-call,
.btn-light .icon-close {
  fill: #fff;
}

.btn-light:hover,
.btn-light:focus,
.btn-light.btn-active,
.btn-light.btn-light--filled {
  background-color: #fff;
  color: #0076dc;
  border-color: #fff;
}

.btn-light:hover .icon-call,
.btn-light:hover .icon-close,
.btn-light:focus .icon-call,
.btn-light:focus .icon-close,
.btn-light.btn-active .icon-call,
.btn-light.btn-active .icon-close,
.btn-light.btn-light--filled .icon-call,
.btn-light.btn-light--filled .icon-close {
  fill: #0076dc;
}

.btn-warning {
  color: #e24e58;
  border-color: #e24e58;
}

.btn-warning:hover,
.btn-warning:focus {
  background-color: #e24e58;
  color: #fff;
}

.btn-warning.btn-active,
.btn-warning.btn-warning--filled {
  background-color: #e24e58;
  color: #fff;
}

.btn-warning.btn-active:hover,
.btn-warning.btn-active:focus,
.btn-warning.btn-warning--filled:hover,
.btn-warning.btn-warning--filled:focus {
  background-color: #f73946;
}

.btn-arrow-right {
  position: relative;
  padding: 0.6875rem 2.1875rem 0.6875rem 0.875rem;
}

.btn-arrow-right::after {
  padding-right: 0.875rem;
  content: "→";
  display: block;
  color: inherit;
  font-size: 1.25rem;
  font-family: monospace;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 0;
  margin-top: 0.0625rem;
}

.btn-add {
  position: relative;
  padding-left: 1.75rem;
}

.btn-add::before,
.btn-add::after {
  position: absolute;
  content: "";
  top: 50%;
  left: 0.75rem;
  width: 0.625rem;
  height: 0.125rem;
  border-radius: 0.0625rem;
  background-color: #fff;
  -webkit-transition: background 0.3s ease;
  transition: background 0.3s ease;
}

.btn-add::before {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

.btn-edit,
.btn-delete,
.btn-more-actions {
  position: relative;
  width: 1.875rem;
  height: 2.25rem;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.btn-edit:hover,
.btn-delete:hover,
.btn-more-actions:hover {
  opacity: 1;
}

.btn-checkbox {
  width: 7.5rem;
  height: 2.25rem;
  position: relative;
  top: 0;
  opacity: 0;
  float: right;
}

// end Specific SIGA buttons

.panel-header {
  position: relative;
  padding: 0 1.875rem;
  height: 4.375rem;
  box-shadow: 0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
}

.step-back + .panel-title {
  padding-left: 1.875rem;
}

.next-step,
.step-back {
  width: auto;
  height: 1.5rem;

  &:hover,
  &:focus {
    cursor: pointer;
  }
}

.service-status-message {
  background: #e9374f;
  margin-bottom: 24px;
  padding: 4px 8px;
  border-radius: 2px;
}

.service-status-message p {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.service-status-message a {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  text-decoration: underline;

  &:hover {
    opacity: 0.9;
  }
}

*[disabled] {
  opacity: 0.55;
  user-select: none;
  pointer-events: none;
}

p {
  font-size: 1rem;
  color: #45555f;
  line-height: 1.375rem;
}

.main {
  position: relative;
  background-color: #e3e8ed;
  color: #1c172f;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.main-content {
  height: calc(100% - #{$header-height});
}

.main-sidebar {
  position: relative;
  width: 18.75rem;
  background-color: #fff;
  -webkit-box-shadow: 0 0.1875rem 0.4375rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.1875rem 0.4375rem 0 rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
}

.main-sidebar > div {
  min-height: 100%;
}

.main-sidebar .message,
.main-sidebar .tickets-solved,
.main-sidebar .ticket-user-details {
  padding: 1.875rem;
}

.main-sidebar .message {
  border-bottom: 0.0625rem solid rgba(28, 23, 47, 0.1);
}

.sidebar-title {
  text-transform: uppercase;
  font-size: 1rem;
  color: #1c172f;
}

.sidebar-right {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 2;
  order: 2;
}

.main.configurations {
  padding: 1.875rem;
}

.queues-list {
  padding: 1.875rem;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow-y: auto;
}

.queue-row {
  height: 4.125rem;
  background-color: #fff;
  font-size: 1.125rem;
  font-weight: 600;
  -webkit-box-shadow: 0 0.1875rem 0.4375rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.1875rem 0.4375rem 0 rgba(0, 0, 0, 0.1);
  padding: 0.9375rem 1.25rem;
  border-radius: 0.25rem;
  margin-bottom: 1.25rem;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.queue,
.tickets-waiting,
.next-ticket,
.next-ticket-waiting {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.queue-labels {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.9375rem 1.25rem;
  text-transform: uppercase;
  font-size: 0.875rem;
  font-weight: 600;
  opacity: 0.6;
  color: #45555f;
}

.queue,
.label-queue {
  -ms-flex-preferred-size: 45%;
  flex-basis: 45%;
}

.tickets-waiting,
.label-tickets-waiting {
  -ms-flex-preferred-size: 15%;
  flex-basis: 15%;
}

.next-ticket,
.label-next-ticket {
  -ms-flex-preferred-size: 15%;
  flex-basis: 15%;
}

.next-ticket-waiting,
.label-next-ticket-waiting {
  -ms-flex-preferred-size: 15%;
  flex-basis: 15%;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

.queue-letter,
.next-ticket-letter {
  width: 1.25rem;
  text-align: center;
  text-transform: uppercase;
}

.queue-letter {
  font-weight: 700;
  margin-right: 0.625rem;
}

.config-queue .queue-letter {
  font-size: 2.125rem;
}

.config-queue .queue-name {
  font-weight: 600;
}

.queue-call-next {
  font-weight: 700;
}

.ticket-priority {
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
}

.ticket-priority::before,
.ticket-priority::after {
  position: absolute;
  content: "";
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 0.75rem;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -webkit-transition: background-color 0.3s ease;
  transition: background-color 0.3s ease;
}

.ticket-priority::before {
  width: 0.75rem;
  height: 0.75rem;
}

.ticket-priority::after {
  width: 0.25rem;
  height: 0.25rem;
}

.low-priority::before {
  background-color: rgba(135, 195, 99, 0.35);
}

.low-priority::after {
  background-color: #87c363;
}

.medium-priority::before {
  background-color: rgba(255, 165, 66, 0.35);
}

.medium-priority::after {
  background-color: #ffa542;
}

.high-priority::before {
  background-color: rgba(255, 118, 131, 0.35);
}

.high-priority::after {
  background-color: #ff7683;
}

.queue-tickets-number {
  font-family: "Klavika-Medium-New", sans-serif;
  font-size: 0.9375rem;
  font-variant-numeric: tabular-nums;
  -webkit-font-feature-settings: "tnum";
  font-feature-settings: "tnum";
  opacity: 1;
  padding: 0.125rem 0.25rem;
  margin-right: 1.25rem;
  cursor: default;
  background-color: #f6f9fc;
  color: rgba(28, 23, 47, 0.6);
  border: 0.0625rem solid #ddd8ec;
  border-radius: 0.125rem;
  position: relative;
}

h2 + ul {
  margin-top: 1.25rem;
}

ul + .btn,
ul + .btn-primary,
ul + .btn-secondary,
ul + .btn-light,
ul + .btn-warning,
ul + button {
  margin-top: 1.875rem;
}

.brand {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.service-acronym {
  font-family: 'Klavika-Medium-New', sans-serif;
  font-size: 1rem;
  margin-left: 0.625rem;
  padding-left: 0.625rem;
  position: relative;
  color: #fff;
}

.service-acronym::before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.0625rem;
  height: 0.875rem;
  background-color: rgba(255, 255, 255, 0.5);
}

.user-name {
  // margin-top: 1rem;
  font-size: 1rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.operator-name {
  font-size: 1rem;
  font-weight: 600;
  max-width: 8.125rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.operator-table {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
  font-size: 0.875rem;
  display: block;
  -webkit-transition: color 0.3s ease;
  transition: color 0.3s ease;
}

.operator-table:hover,
.operator-table:focus {
  color: #fff;
}

.operator-name,
.btn-logout {
  display: inline-block;
  vertical-align: middle;
}

.input-group + .label-user {
  margin-top: 8px;
}

.label-user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;

  // background: $slate;
  background: $light-blue;
  color: $dark;
  font-weight: 600;
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.label-ticket {
  @extend .label-user;

  .link {
    font-weight: 400;
  }
}

.label-user .avatar {
  width: 32px;
  height: 32px;

  img {
    border: 2px solid #fff;
  }
}

.avatar {
  width: 3.75rem;
  height: 3.75rem;
  margin-right: 0.625rem;
  // align-self: flex-start;
}

.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 1.875rem;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: top center;
  object-position: top center;
  -webkit-box-shadow: 0 0 0.125rem 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 0.125rem 0 rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

.ticket-user .avatar {
  width: 2.5rem;
  height: 2.5rem;
}

.main-sidebar .operator,
.main-sidebar .ticket-user {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 1.875rem;
  border-bottom: 0.0625rem solid rgba(28, 23, 47, 0.1);
}

.main-sidebar .operator p,
.main-sidebar .operator-name,
.main-sidebar .ticket-user-name {
  font-size: 1.125rem;
}

.main-sidebar .operator-table {
  color: #0076dc;
  font-weight: 700;
  font-size: 1rem;
}

.main-sidebar .ticket-user-name {
  font-weight: 700;
}

// .tickets-solved-list .ticket-solved-item {
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: justify;
//   -ms-flex-pack: justify;
//   justify-content: space-between;
//   color: #45555F;
//   padding-bottom: 0.625rem;
//   border-bottom: 0.0625rem solid rgba(28, 23, 47, 0.1)
// }

// .tickets-solved-list .ticket-solved-item~.ticket-solved-item {
//   margin-top: 0.625rem
// }

// .tickets-solved-list .number-ticket-solved {
//   font-weight: 600
// }

// .time-ticket-solved {
//   opacity: 0.6
// }

.queue--empty .ticket-priority {
  display: none;
}

.white-panel {
  width: 100%;
  height: 100%;
  background-color: #fff;
  -webkit-box-shadow: 0 0.4375rem 0.625rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.4375rem 0.625rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
  overflow: hidden;
  position: relative;
}

.config-panel,
.panel-content {
  padding: 0 1.875rem;
}

.config-panel__narrow {
  padding: 0 3.75rem;
}

.config-panel.moves-out {
  transform: translateX(-100%);
}

.config-panel > .label-primary {
  margin: 40px 0 0;
}

.panel-scroll {
  width: 100%;
  height: calc(100% - 4.375rem);
  overflow-x: hidden;
  overflow-y: auto;
}

.system-users-list .avatar {
  width: 2.5rem;
  height: 2.5rem;
}

.panel-title,
.action-buttons {
  display: inline-block;
}

.panel-title {
  font-weight: 600;
}

.row {
  padding: 2.5rem 0;
  border-bottom: 0.0625rem solid rgba(0, 0, 0, 0.1);
  position: relative;
}

.system-table,
.system-user,
.config-queue {
  -webkit-transition: opacity 0.5s ease 0.5s, visibility 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s, -webkit-transform 0.5s ease 0.5s;
  transition: opacity 0.5s ease 0.5s, visibility 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s, -webkit-transform 0.5s ease 0.5s;
  transition: opacity 0.5s ease 0.5s, visibility 0.5s ease 0.5s, transform 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s;
  transition: opacity 0.5s ease 0.5s, visibility 0.5s ease 0.5s, transform 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s, -webkit-transform 0.5s ease 0.5s;
}

.row-small,
.row-narrow {
  padding: 1.5625rem 1.25rem;
}

.row .config-label {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.625rem;
}

.row .config-description {
  font-size: 1.0625rem;
  color: #45555f;
}

.config-queue {
  height: 5rem;
}

.flex-center {
  display: flex;
  align-items: center;
}

.hours-interval {
  margin: 0.625rem 1.25rem;
}

.hours-interval:first-of-type {
  margin-left: 0;
}

.label-primary,
.hours-on,
.hours-off {
  font-size: 1.5rem;
  font-weight: 700;
}

.label-primary span,
.hours-on span,
.hours-off span {
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.3125rem;
  font-size: 0.75rem;
  color: #282c35;
  line-height: 1.625rem;
}

.label-secondary {
  color: rgba(69, 85, 95, 0.7);
  letter-spacing: 0.0019rem;
  text-transform: uppercase;
  border: 0.0625rem solid rgba(69, 85, 95, 0.6);
  border-radius: 0.25rem;
  padding: 0.125rem 0.3125rem;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 0.6875rem;
  display: inline-block;
  vertical-align: middle;
  -webkit-transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

.label-secondary ~ .label-secondary {
  margin-left: 0.3125rem;
}

.hours-on {
  margin-right: 0.625rem;
}

.hours-off {
  margin-left: 0.625rem;
}

.device-name {
  font-size: 1.25rem;
  font-weight: 600;
}

.device-brand {
  opacity: 0.6;
  margin-top: 0.625rem;
}

.device-name,
.device-locate {
  display: inline-block;
  vertical-align: middle;
}

.device,
.device-configs {
  padding-left: 2.5rem;
}

// .device-configs {
//   margin-top: 1.5625rem
// }

.device-configs .input {
  margin-bottom: 0.9375rem;
}

.device-configs > * {
  display: inline-block;
  vertical-align: middle;
}

.device-configs label {
  padding-right: 0.5rem;
  font-weight: 600;
}

.device-configs .input-checkbox,
.device-configs .input-range {
  margin-right: 2.5rem;
}

.device-configs .input-checkbox:last-of-type,
.device-configs .input-range:last-of-type {
  margin-right: 0;
}

.device-configs .input-range label {
  min-width: 3.75rem;
}

.more-options {
  color: #0076dc;
  text-decoration: underline;
  font-size: 0.875rem;
  line-height: 1.4;
  margin-top: 0.375rem;
}

.queue-data,
.queue-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.queue-tickets-number .tickets-total,
.queue-tickets-number .reseted-number {
  display: block;
}

.queue-tickets-number .tickets-total {
  -webkit-transition: opacity 0.3s ease 1.6s, visibility 0.3s ease 1.6s, -webkit-transform 0.3s ease 1.6s;
  transition: opacity 0.3s ease 1.6s, visibility 0.3s ease 1.6s, -webkit-transform 0.3s ease 1.6s;
  transition: opacity 0.3s ease 1.6s, visibility 0.3s ease 1.6s, transform 0.3s ease 1.6s;
  transition: opacity 0.3s ease 1.6s, visibility 0.3s ease 1.6s, transform 0.3s ease 1.6s, -webkit-transform 0.3s ease 1.6s;
}

.queue-tickets-number .reseted-number {
  position: absolute;
  top: -0.25rem;
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s ease 1.6s, visibility 0.3s ease 1.6s, top 0.3s ease 1.6s;
  transition: opacity 0.3s ease 1.6s, visibility 0.3s ease 1.6s, top 0.3s ease 1.6s;
}

@-webkit-keyframes flash {

  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

@keyframes flash {

  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

@-webkit-keyframes changeBg {
  from {
    background-color: #0076dc;
    color: #fff;
    border: 0.0625rem solid #0076dc;
  }

  to {
    background-color: #f6f9fc;
    color: rgba(28, 23, 47, 0.6);
    border: 0.0625rem solid #beb6db;
  }
}

@keyframes changeBg {
  from {
    background-color: #0076dc;
    color: #fff;
    border: 0.0625rem solid #0076dc;
  }

  to {
    background-color: #f6f9fc;
    color: rgba(28, 23, 47, 0.6);
    border: 0.0625rem solid #beb6db;
  }
}

.updated-tickets-number {
  background-color: #0076dc;
  color: #fff;
  border: 0.0625rem solid #0076dc;
  -webkit-animation: 1s ease 0s 1 flash, 0.16s linear 4s 1 normal forwards changebg;
  animation: 1s ease 0s 1 flash, 0.16s linear 4s 1 normal forwards changeBg;
}

.updated-tickets-number .tickets-total {
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.updated-tickets-number .reseted-number {
  opacity: 1;
  visibility: visible;
  top: 0.125rem;
}

.config-queue.fade {
  margin-bottom: -0.5rem;
}

.system-table.fade {
  margin-bottom: -4.9375rem;
}

.system-user.fade {
  margin-bottom: -0.5813rem;
}

.fade {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  -webkit-transform: scale(0.96);
  transform: scale(0.96);
  -webkit-transition: opacity 0.18s ease 0.5s, visibility 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s, -webkit-transform 0.5s ease 0.5s;
  transition: opacity 0.18s ease 0.5s, visibility 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s, -webkit-transform 0.5s ease 0.5s;
  transition: opacity 0.18s ease 0.5s, visibility 0.5s ease 0.5s, transform 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s;
  transition: opacity 0.18s ease 0.5s, visibility 0.5s ease 0.5s, transform 0.5s ease 0.5s, margin-bottom 0.5s ease 0.5s, -webkit-transform 0.5s ease 0.5s;
}

.will-fade-in {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: scale(0.94);
  transform: scale(0.94);
}

.faded-out {
  opacity: 0;
  visibility: hidden;
}

.faded-in {
  opacity: 1;
  visibility: visible;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.hidden {
  display: none;
}

.text-center,
.empty-state {
  text-align: center;
}

.action-disabled {
  cursor: not-allowed;
}

.queue-action {
  margin-top: 0.0625rem;
}

.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.flex--col {
  flex-direction: column;
}

.flex.full-width {
  width: 100vw;
}

.flex.full-height {
  height: 100vh;
}

.space-between {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>
